import { AdaptiveDesignSystem, selectAestheticStyles, selectStyleModules, selectTemplateStyles, composeSelect, SelectStatics } from "@adaptive-web/adaptive-web-components";
import { css } from "@microsoft/fast-element";

import chevronDown from '/icons/chevron-down.svg?raw';
import { MatchMediaStyleSheetBehavior } from '@microsoft/fast-foundation';
import { darkModeQuery } from '../../style.js';
import { cornerRadiusControl, focusStrokeOuter, focusStrokeThickness } from '@adaptive-web/adaptive-ui/reference';

export const customSelectDefinition = composeSelect(AdaptiveDesignSystem, {
  styleModules: selectStyleModules,
  statics: {
    [SelectStatics.indicator]: chevronDown
  },
  styles: [
    selectTemplateStyles,
    selectAestheticStyles,
    css`
      .control {
        background-color: var(--background-color) !important;
        border-radius: ${cornerRadiusControl};
      }

      .listbox {
        background-color: var(--background-color) !important;
      }

      ::slotted([aria-selected="true"]:not(.placeholder)),
      ::slotted([aria-selected="true"]:hover) {
        background-color: var(--primary-color) !important;
        color: #ffffff !important;
      }

      ::slotted(:hover) {
        background-color: var(--surface-color) !important;
        color: #000000 !important;
      }

      ::slotted(.placeholder),
      ::slotted(.placeholder:hover) {
        pointer-events: none;
        cursor: not-allowed;
        opacity: 0.5;
        background-color: transparent !important;
        color: var(--neutral-foreground-rest) !important;
      }

      :host([disabled]) .label,
      :host([disabled]) .control {
        color: var(--text-color) !important;
      }

      :host .control:autofill,
      :host .control:-webkit-autofill,
      :host .control:autofill:focus,
      :host .control:-webkit-autofill:focus,
      :host .control:-internal-autofill-selected {
        -webkit-box-shadow: 0 0 0 1000px var(--background-color) inset !important;
      }

      :host(:focus-within) {
        outline: ${focusStrokeThickness} solid ${focusStrokeOuter};
        outline-offset: 1px;
        border-radius: ${cornerRadiusControl};
      }
    `.withBehaviors(
      new MatchMediaStyleSheetBehavior(
        darkModeQuery,
        css`
          ::slotted([aria-selected="true"]:not(.placeholder)),
          ::slotted([aria-selected="true"]:hover) {
            background-color: var(--surface-color) !important;
            color: #ffffff !important;
          }

          ::slotted(:hover) {
            background-color: #bddeff !important;
            color: #000000 !important;
          }
        `
      )
    )
  ]
});